import template from './template.html';
import blockBase from "../../mixins/blockBase";
import { Carousel3d, Slide } from 'vue-carousel-3d';
import {includes, remove} from 'lodash';

export default {
    name: 'carousel',
    template: template,
    props: {
        images: Array,
        active_prop: Array,
    },
    data() {
      return {
          active: this.active_prop,
      }
    },
    mixins: [
        blockBase,
    ],
    components: {
        Carousel3d,
        Slide
    },
    methods: {
        isActive(index) {
            return includes(this.active, index);
        },
        addActiveItem(index) {
            this.$set(this, 'active', [index]);
        },
        goToSlide(index) {
            this.$refs.carousel.goSlide(index);
            this.addActiveItem(index);
        },
        onAfterSlideChange() {
            this.addActiveItem(this.$refs.carousel.currentIndex);
        }
    }
};